import { connect } from 'react-redux';

import { getPOSData } from '@olxbr/mojo-jojo/selectors/pos';
import { getAdData } from '@olxbr/mojo-jojo/selectors/ad';
import { getExtrasData } from '@olxbr/mojo-jojo/selectors/extras';
import { getProductsData } from '@olxbr/mojo-jojo/selectors/products';

import AutosPlansSubscription from './index';

const mapStateToProps = state => ({
  posData: getPOSData(state),
  productsData: getProductsData(state),
  adData: getAdData(state),
  extrasData: getExtrasData(state),
});

export default connect(mapStateToProps, {})(AutosPlansSubscription);
